import { gql } from '@apollo/client';
import { EMAIL_TEMPLATE_FIELDS } from './EmailTemplate.fragment';
import { SITE_FIELDS } from './Site.fragment';

export const NEWS_ALERT_FIELDS = gql`
  ${SITE_FIELDS}
  ${EMAIL_TEMPLATE_FIELDS}
  fragment NewsAlertFields on newsAlert {
    id
    body
    buttonLabel
    buttonUrl
    photoType
    photoUrl
    teaser
    emailTemplateId
    mailchimpCampaignId
    utm
    trendingEvents
    trendingPlaces
    newsItems
    title
    isSent
    sendDate
    sendTime
    siteId
    style
    subject
    site {
      ...SiteFields
    }
    emailTemplate {
      ...EmailTemplateFields
    }
  }
`;
